import moment from 'moment';
import Card from '../../../components/Card';
import { formatAmountWithSuffix } from '../../../helpers';
import UserReferral from '../../../components/UserReferral';
import { UserReferralList } from '.';

type ReferralListRowProps = {
    payout: UserReferralList;
    style?: React.CSSProperties;
};

const ReferralListRow: React.FC<ReferralListRowProps> = ({ payout, style }) => {
    const { referralDate, totalEarnings, totalVolume, userAddress } = payout;

    return (
        <Card className='referral-list__row row' style={style}>
            <div className='referral-list__referral-date'>
                <span className='column-label'>Ref. Date</span>
                {moment.unix(referralDate).format('YYYY-MM-DD HH:mm:ss')}
            </div>
            <div className='referral-list__user'>
                <span className='column-label'>User</span>
                <UserReferral userAddress={userAddress} />
            </div>
            <div className='referral-list__total-earnings'>
                <span className='column-label'>Total Earnings</span>
                {formatAmountWithSuffix(totalEarnings, {
                    minDecimals: 2,
                    currency: 'USD',
                    minValue: 1_000_000_000,
                })}
            </div>
            <div className='referral-list__total-volume'>
                <span className='column-label'>Volume</span>
                {formatAmountWithSuffix(totalVolume, {
                    minDecimals: 2,
                    currency: 'USD',
                    minValue: 1_000_000_000,
                })}
            </div>
        </Card>
    );
};

export default ReferralListRow;
